import React, { ReactElement } from 'react';
import { Header as UIHeader } from 'components/ui';
import { useProfile } from 'hooks';
import { useMediaQuery, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { RoleMap } from 'hooks/useGetRole';

export const Header = (): ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const { profile, loading } = useProfile();
  const isLoggedIn = !!profile;

  const router = useRouter();

  React.useEffect(() => {
    if (
      profile &&
      profile?.signupStep !== 'COMPLETE' &&
      profile?.role.includes(RoleMap.user)
    ) {
      if (router.pathname === '/events/[id]/check-in') return;
      void router.push('/signup-confirm');
    }
  }, [profile?.signupStep, router.pathname]);

  return (
    <UIHeader
      showActions={!loading}
      loggedIn={isLoggedIn}
      showLogo={isDesktop}
    />
  );
};
